import React from 'react';
import { Link } from 'react-router';
const BreadcrumbItem = ({
  link,
  className
}) => /*#__PURE__*/React.createElement(Link, {
  className: className,
  to: {
    pathname: link.href,
    state: {
      shouldProductsBeReseted: true
    }
  }
}, link.text);
export default BreadcrumbItem;